import React, { useState } from 'react';
import ApexCharts from 'react-apexcharts';
import '../InsiderTradeLine/InsiderTradeLine.css';

const InsiderTradeLine = () => {
  const [chartOptions] = useState({
    chart: {
      height: 350,
      type: 'line',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false, // Removes the hamburger menu
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'straight',
    },
    grid: {
      show: true,
      borderColor: '#e0e0e0', // Set a light color for grid lines
      strokeDashArray: 0, // Solid grid lines
      row: {
        colors: undefined, // Removes background colors
        opacity: 0, // Ensures no background color opacity
      },
      column: {
        colors: undefined, // Removes column background colors
        opacity: 0, // Ensures no column background color opacity
      },
    },    
    xaxis: {
      type: 'date', // Use datetime for x-axis
      categories: [
        '2023-01',
        '2023-02',
        '2023-03',
        '2023-04',
        '2023-05',
        '2023-06',
        '2023-07',
        '2023-08',
        '2023-09',
      ],
      labels: {
        formatter: function (value) {
          // Format date as 'YYYY-MM'
          const date = new Date(value);
          const year = date.getFullYear();
          const month = ('0' + (date.getMonth() + 1)).slice(-2); // Ensures month is 2 digits
          return `${year}-${month}`;
        },
      },
    },
    yaxis: {
      opposite: true, // Move Y-axis to the right side
      title: {
        text: 'Price', // Y-axis title
      },
      min: 0, // Adjust the minimum value of the Y-axis
      max: 200, // Adjust the maximum value of the Y-axis to add more range
      tickAmount: 10, // Adjust the number of ticks for more control
    },
    
    tooltip: {
      shared: true,
      custom: function ({ series, dataPointIndex, seriesIndex }) {
        // Safely access the values for each series and check for undefined
        const insiderBuys = series[0] ? series[0][dataPointIndex] : 'N/A';
        const insiderSells = series[1] ? series[1][dataPointIndex] : 'N/A';
        const price = series[2] ? series[2][dataPointIndex] : 'N/A';

        // Get the colors for each series based on seriesIndex
        const colorInsiderBuys = chartOptions.colors[0];
        const colorInsiderSells = chartOptions.colors[1];
        const colorPrice = chartOptions.colors[2];

        return `
          <div style="padding: 10px;">
            <strong>Date:</strong> ${chartOptions.xaxis.categories[dataPointIndex]}<br />
            <strong>Price:</strong> <span style="color:${colorPrice};">${price !== 'N/A' ? price.toFixed(2) : 'N/A'}</span><br />
            <strong>Insider Buys:</strong> <span style="color:${colorInsiderBuys};">${insiderBuys !== 'N/A' ? insiderBuys.toFixed(2) : 'N/A'}</span><br />
            <strong>Insider Sells:</strong> <span style="color:${colorInsiderSells};">${insiderSells !== 'N/A' ? insiderSells.toFixed(2) : 'N/A'}</span>
          </div>
        `;
      },
    },
    legend: {
      show: true, // Show legend
      position: 'bottom', // Place the legend at the bottom
      horizontalAlign: 'center', // Align legend horizontally in the center
      floating: false, // Disable floating for fixed legend position
      offsetY: 10, // Adjust the vertical position slightly to avoid overlapping
    },
    
    colors: ['#00E396', '#FF4560', '#008FFB'], // Define the series colors (adjust as needed)
  });

  const [series] = useState([
    {
      name: 'Insider Buys',
      data: [5, 15, 25, 35, 45, 55, 65, 75, 85], // Data for Insider Buys
    },
    {
      name: 'Insider Sells',
      data: [10, 20, 30, 40, 50, 60, 70, 80, 90], // Data for Insider Sells
    },
    {
      name: 'Price',
      data: [10, 41, 35, 51, 49, 62, 69, 91, 148], // Data for Price
    },
  ]);

  return (
    <div className="insider-container">
      <h2>Insider Trades and Price Trends Over Time</h2>
      <div id="chart">
        <ApexCharts
          options={chartOptions}
          // Only show the "Price" series on the chart, while keeping all series for the tooltip
          series={[series[2]]} 
          type="line"
          height={400}
        />
      </div>
    </div>
  );
};

export default InsiderTradeLine;
